import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Text,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Divider,
  RadioGroup,
  Radio,
  Icon,
  IconButton,
  Spinner,
  HStack,
  Stack,
  useToast,
  useDisclosure,
  SimpleGrid,
  FormErrorMessage,
  Textarea,
  VStack,
  Badge,
  Card,
  CardBody
} from '@chakra-ui/react';
import { AddIcon, EditIcon, DeleteIcon } from '@chakra-ui/icons';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { FaApple, FaBitcoin, FaCreditCard, FaInstagram, FaTwitter, FaFacebook, FaYoutube, FaTiktok, FaSpotify } from 'react-icons/fa';
import { Controller, useForm } from 'react-hook-form';
import { useSubscription } from '../../../context/SubscriptionContext';
import { useAuth } from '../../../hooks/useAuth';
import ConfirmationModal from '../../../tools/ConfirmationModal';
import CustomSelect from '../../../utils/CustomSelect';
import axiosInstance from '../../../services/axios';





const PaymentMethodSelect = ({ selectedPaymentMethod, setSelectedPaymentMethod }) => (
  <FormControl w="100%" mt={4} bg="secondary.900" p={3} borderRadius="md">
    <FormLabel fontSize="lg" fontWeight="bold" color="primary.500">
      Payment Method
    </FormLabel>
    <RadioGroup onChange={setSelectedPaymentMethod} value={selectedPaymentMethod}>
      <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
        <Box display="flex" alignItems="center" cursor="pointer">
          <Radio value="card" colorScheme="blue">
            <HStack>
              <Icon as={FaCreditCard} boxSize={5} />
              <Text color="primary.500">Card</Text>
            </HStack>
          </Radio>
        </Box>
        <Box display="flex" alignItems="center" cursor="pointer">
          <Radio value="applePay" colorScheme="blue" isDisabled>
            <HStack>
              <Icon as={FaApple} boxSize={5} />
              <Text color="primary.500">Apple Pay</Text>
            </HStack>
          </Radio>
        </Box>
        <Box display="flex" alignItems="center" cursor="pointer">
          <Radio value="cryptoPay" colorScheme="blue" isDisabled>
            <HStack>
              <Icon as={FaBitcoin} boxSize={5} />
              <Text color="primary.500">Crypto Pay</Text>
            </HStack>
          </Radio>
        </Box>
      </Stack>
    </RadioGroup>
  </FormControl>
);

const BillingDetailsForm = ({ register, errors, countries, control }) => {

  return (

    <Box color="primary.100">
      {console.log(countries)}
      <FormControl fontSize={{ base: 'sm', md: 'md' }} mt={4} color="primary.100" isInvalid={errors.cardName}>
        <FormLabel>Name on Card</FormLabel>
        <Input
          type="text"
          {...register("cardName", { required: "Name on card is required" })}
          variant="filled"
        />
        <FormErrorMessage>{errors.cardName && errors.cardName.message}</FormErrorMessage>
      </FormControl>
      {/* Additional Billing Details */}
      <SimpleGrid columns={2} spacing={4} mt={4}>
        <FormControl fontSize={{ base: 'sm', md: 'md' }} color="primary.100" isInvalid={errors.billingAddress}>
          <FormLabel fontSize={{ base: 'sm', md: 'md' }} color="primary.100">
            Billing Address
          </FormLabel>
          <Input
            type="text"
            {...register('billingAddress', {
              required: 'Address line 1 is required',
            })}
            variant="filled"
            size="md"
            w="full"
     
          />
          <FormErrorMessage>
            {errors.billingAddress && errors.billingAddress.message}
          </FormErrorMessage>
        </FormControl>
        <FormControl fontSize={{ base: 'sm', md: 'md' }} color="primary.100" isInvalid={errors.city}>
          <FormLabel>City</FormLabel>
          <Input
            type="text"
            {...register("city", { required: "City is required" })}
            variant="filled"
          />
          <FormErrorMessage>{errors.city && errors.city.message}</FormErrorMessage>
        </FormControl>
        <FormControl  isInvalid={errors.state}>
          <FormLabel>State</FormLabel>
          <Input
            type="text"
            {...register("state", { required: "State is required" })}
            variant="filled"
          />
          <FormErrorMessage>{errors.state && errors.state.message}</FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={!!errors.country}>
    <FormLabel fontSize={{ base: "sm", md: "md" }} color="primary.100">
      Country
    </FormLabel>

    <Controller
      name="country"
      control={control}
      rules={{ required: "Country is required" }}
      fontSize={{ base: 'sm', md: 'md' }} color="primary.100"
      render={({ field }) => (
        <CustomSelect
          value={field.value}
          onChange={field.onChange}
          placeholder="Select a country"
          width="100%"
        >
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.name}
            </option>
          ))}
        </CustomSelect>
      )}
    />

    <FormErrorMessage>
      {errors.country?.message}
    </FormErrorMessage>
  </FormControl>
        <FormControl isInvalid={errors.postalCode}>
          <FormLabel fontSize={{ base: 'sm', md: 'md' }} color="primary.100">
            ZIP/Postal Code
          </FormLabel>
          <Input
            type="text"
            {...register('postalCode', {
              required: 'ZIP/Postal code is required',
            })}
            variant="filled"
            size="md"
            w="full"

          />
          <FormErrorMessage>
            {errors.postalCode && errors.postalCode.message}
          </FormErrorMessage>
        </FormControl>
      </SimpleGrid>
    </Box>
  );
}

const Settings = () => {
  const {
    userSubscription,
    paymentMethods,
    getPaymentMethods,
    setDefaultPaymentMethod,
    createPaymentMethod,
    addPaymentMethod,
    stopAutoRenewal,
    startAutoRenewal,
    deletePaymentMethod,
    loading,
    fetchUserSubscription
  } = useSubscription();

  const stripe = useStripe();
  const elements = useElements();
  const { register, handleSubmit, formState: { errors },control} = useForm();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('card');
  const [isAdding, setIsAdding] = useState(false);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const toast = useToast();
  const { user } = useAuth();

  // Bio and Social Media State
  const [bio, setBio] = useState('');
  const [isEditingBio, setIsEditingBio] = useState(false);
  const [bioLoading, setBioLoading] = useState(false);
  const [socialMedia, setSocialMedia] = useState([]);
  const [isAddingSocial, setIsAddingSocial] = useState(false);
  const [socialLoading, setSocialLoading] = useState(false);
  const [newSocial, setNewSocial] = useState({ platform: '', handle: '' });
  const [profileLoading, setProfileLoading] = useState(true);

  // Available social platforms
  const socialPlatforms = [
    { value: 'instagram', label: 'Instagram', icon: FaInstagram, color: '#E4405F' },
    { value: 'twitter', label: 'Twitter', icon: FaTwitter, color: '#1DA1F2' },
    { value: 'facebook', label: 'Facebook', icon: FaFacebook, color: '#1877F2' },
    { value: 'youtube', label: 'YouTube', icon: FaYoutube, color: '#FF0000' },
    { value: 'tiktok', label: 'TikTok', icon: FaTiktok, color: '#000000' },
    { value: 'spotify', label: 'Spotify', icon: FaSpotify, color: '#1ED760' }
  ];

  useEffect(() => {
    fetchUserProfile();
    getPaymentMethods();
  }, []);

  // Fetch user profile data
  const fetchUserProfile = async () => {
    setProfileLoading(true);
    try {
      const userResponse = await axiosInstance.get('/users/me');
      const userData = userResponse.data;
      
      let artistData = null;
      try {
        const artistResponse = await axiosInstance.get(`/users/artist/profile?user_id=${userData.user_id}`);
        artistData = artistResponse.data;
      } catch (artistError) {
        // Artist profile not found, use user data
      }
      
      const profileData = artistData || userData;
      setBio(profileData.bio || '');
      setSocialMedia(profileData.social_media_handles || profileData.social_media || []);
    } catch (error) {
      console.error('Error fetching user profile:', error);
    } finally {
      setProfileLoading(false);
    }
  };

  // Update bio
  const updateBio = async () => {
    setBioLoading(true);
    try {
      await axiosInstance.put('/users/update/bio', { bio });
      setIsEditingBio(false);
      toast({
        title: "Bio updated",
        description: "Your bio has been updated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error updating bio:', error);
      toast({
        title: "Error",
        description: "Failed to update bio",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setBioLoading(false);
    }
  };

  // Generate URL for social media platform
  const generateSocialUrl = (platform, handle) => {
    switch (platform) {
      case 'instagram': return `https://instagram.com/${handle}`;
      case 'twitter': return `https://twitter.com/${handle}`;
      case 'facebook': return `https://facebook.com/${handle}`;
      case 'youtube': return `https://youtube.com/@${handle}`;
      case 'tiktok': return `https://tiktok.com/@${handle}`;
      case 'spotify': return `https://open.spotify.com/user/${handle}`;
      default: return '';
    }
  };

  // Add social media
  const handleAddSocial = async () => {
    if (!newSocial.platform || !newSocial.handle) {
      toast({
        title: "Error",
        description: "Please select a platform and enter a handle",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Check if platform already exists
    const existingPlatform = socialMedia.find(social => social.platform === newSocial.platform);
    if (existingPlatform) {
      toast({
        title: "Platform already exists",
        description: `You already have a ${newSocial.platform} account linked. Please remove it first to add a new one.`,
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    setSocialLoading(true);
    try {
      const newSocialWithUrl = {
        platform: newSocial.platform,
        handle: newSocial.handle.replace('@', ''), // Remove @ if present
        url: generateSocialUrl(newSocial.platform, newSocial.handle.replace('@', ''))
      };
      
      // Create a new array with the existing social media plus the new one
      const updatedSocialMedia = [...(socialMedia || []), newSocialWithUrl];
      
      const response = await axiosInstance.put('/users/update/social-media', { 
        social_media_handles: updatedSocialMedia 
      });
      
      // Update local state with the response from server
      if (response.data && response.data.social_media_handles) {
        setSocialMedia(response.data.social_media_handles);
      } else {
        setSocialMedia(updatedSocialMedia);
      }
      
      setNewSocial({ platform: '', handle: '' });
      setIsAddingSocial(false);
      toast({
        title: "Social media added",
        description: "Social media platform has been added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error adding social media:', error);
      toast({
        title: "Error",
        description: "Failed to add social media platform",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSocialLoading(false);
    }
  };

  // Remove social media
  const handleRemoveSocial = async (index) => {
    setSocialLoading(true);
    try {
      const updatedSocialMedia = socialMedia.filter((_, i) => i !== index);
      
      const response = await axiosInstance.put('/users/update/social-media', { 
        social_media_handles: updatedSocialMedia 
      });
      
      // Update local state with the response from server
      if (response.data && response.data.social_media_handles) {
        setSocialMedia(response.data.social_media_handles);
      } else {
        setSocialMedia(updatedSocialMedia);
      }
      
      toast({
        title: "Social media removed",
        description: "Social media platform has been removed successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error('Error removing social media:', error);
      toast({
        title: "Error",
        description: "Failed to remove social media platform",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setSocialLoading(false);
    }
  };


  const CARD_OPTIONS = {
    style: {
      base: {
        fontSize: "16px",
        color: "#424770", // ✅ Your requested text color
        fontFamily: "Poppins, sans-serif",
        "::placeholder": { color: "#aab7c4" }, // ✅ Your requested placeholder color
        padding: "12px",
        backgroundColor: "transparent",
        borderRadius: "6px",
      },
      invalid: {
        color: "#ff4c4c", // Error text color
        iconColor: "#ff4c4c",
      },
      complete: {
        color: "#4caf50", // Success color
      },
    },
    hidePostalCode: true, // Hide postal code if not needed
    disableLink: true,
  };

  const handleAddPaymentMethod = async (data) => {
    setIsPaymentLoading(true);
    try {
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) throw new Error('Card Element not found.');
      const billingDetails = {
        name: data.cardName,
        address: {
          line1: data.billingAddress,
          city: data.city,
          state: data.state,
          postal_code: data.postalCode,
          country: data.country,
        },
      };
      const paymentMethodId = await createPaymentMethod(cardElement, stripe, billingDetails);
      await addPaymentMethod(paymentMethodId);
      setIsAdding(false);
    } catch (error) {
      console.error('Error adding payment method:', error);
    } finally {
      setIsPaymentLoading(false);
    }
  };



  // Modal controls from Chakra UI.
  const { isOpen, onOpen, onClose } = useDisclosure();
  // State to track which action we're confirming.
  const [pendingAction, setPendingAction] = useState(null);

  const handleToggleAutoRenewal = async () => {
    // If auto-renewal is active (cancel_at_period_end is false), require confirmation.
    if (!userSubscription.cancelation_at_period_end) {
      setPendingAction("cancel");
      onOpen();
    } else {
      // Otherwise, if auto-renewal is already off, start it immediately.
      await processAction("start");
    }
  };

  const processAction = async (action) => {
    try {
      if (action === "start") {
        await startAutoRenewal();
      
        toast({
          title: "Auto-renewal started",
          description: "Your subscription will now auto-renew.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else if (action === "cancel") {
        await stopAutoRenewal();
        toast({
          title: "Auto-renewal canceled",
          description:
            "Your subscription will not auto-renew after the current period.",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
      await fetchUserSubscription();
    } catch (error) {
      toast({
        title: "Error",
        description: "There was an error updating your subscription.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleConfirm = async () => {
    onClose();
    await processAction(pendingAction);
    setPendingAction(null);
  };


  return (
    <Box mt={4}>

      <Box mb={8}>
        <Heading size="md" mb={4} color="primary.500">
          Current Subscription
        </Heading>
        {loading ? (
          <Spinner size="lg" color="primary.500" />
        ) : userSubscription ? (
          <Box p={4} borderRadius="md" bg="secondary.500">
            <Flex
              justify="space-between"
              align={{ base: "flex-start", md: "center" }}
              flexDirection={{ base: "column", md: "row" }}
            >
              <Box>
                <Text fontWeight="bold" color="primary.900">
                  {userSubscription.plan || "Plan Name"}
                </Text>
                <Text color="primary.500">
                  Price: ${userSubscription.unit_amount / 100}/month
                </Text>
                <Text color="primary.500">
                  Status: {userSubscription.status || "Unknown"}
                </Text>
                <Text color="primary.500">
                  Current Period Ends:{" "}
                  {new Date(userSubscription.current_period_end * 1000).toLocaleDateString()}
                </Text>
                <Text color="primary.500">
                  Auto-renewal:{" "}
                  {userSubscription.cancelation_at_period_end ? "Cancelled" : "Active"}
                </Text>
              </Box>
              <Button
                colorScheme={userSubscription.cancelation_at_period_end ? "green" : "red"}
                my={6}
                size="sm"
                onClick={handleToggleAutoRenewal}
              >
                {userSubscription.cancelation_at_period_end
                  ? "Restart Subscriptiion"
                  : "Cancel Subscription"}
              </Button>
            </Flex>
          </Box>
        ) : (
          <Text color="primary.500">No active subscription found.</Text>
        )}

        {/* Reusable Confirmation Modal */}
        <ConfirmationModal
          isOpen={isOpen}
          onClose={() => {
            setPendingAction(null);
            onClose();
          }}
          onConfirm={handleConfirm}
          title="Confirm Cancellation"
          message="Are you sure you want to cancel your subscription? Your subscription will not renew at the end of the current billing period if you cancel."
          confirmButtonText="Yes, Cancel"
          cancelButtonText="Keep Subscription"
          confirmButtonColorScheme="red"
        />
      </Box>

      <Box mb={8}>
        <Heading size="md" mb={4} color="primary.500">Payment Methods</Heading>
        {loading ? (
          <Spinner size="lg" color="primary.500" />
        ) : paymentMethods.length === 0 ? (
          <Text color="primary.500">No payment methods available.</Text>
        ) : (
          paymentMethods.map((method) => (

            <Flex key={method.id} align={{ base: "flex-start", md: "center" }} flexDirection={{ base: "column", md: "row" }} justify="space-between" p={4} borderWidth="1px" borderRadius="md" bg="secondary.500" mb={4}>

              <Box>
                <Text color="primary.900">**** **** **** {method.card.last4} ({method.card.brand})</Text>
                <Text color="primary.500">Expires: {method.card.exp_month}/{method.card.exp_year}</Text>
              </Box>

              <Flex my={5}>
                <Button mr={2} size="sm" onClick={() => setDefaultPaymentMethod(method.id)} isDisabled={method.is_default}>
                  {method.is_default ? 'Default' : 'Set Default'}
                </Button>
                <Button size="sm" onClick={() => deletePaymentMethod(method.id)}>Delete</Button>

              </Flex>
            </Flex>
          ))
        )}
      </Box>

      <Box mb={8}>
        {isAdding ? (
          <Box as="form" onSubmit={handleSubmit(handleAddPaymentMethod)}>
            <Heading size="md" mb={4} color="primary.500">Add Payment Method</Heading>
            <PaymentMethodSelect selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} />
            {selectedPaymentMethod === 'card' && (
              <>
                <BillingDetailsForm countries={[
                  { name: "United States", code: "US" },
                  { name: "Canada", code: "CA" },
                  { name: "United Kingdom", code: "GB" },
                  { name: "Australia", code: "AU" },
                  { name: "Germany", code: "DE" },
                  { name: "France", code: "FR" },
                  { name: "India", code: "IN" },
                  { name: "Japan", code: "JP" },
                  { name: "Brazil", code: "BR" },
                  { name: "Mexico", code: "MX" },
                  { name: "South Africa", code: "ZA" },
                  { name: "Singapore", code: "SG" },
                ]} register={register} errors={errors} control={control}/>
                <FormControl mt={4}>
                  <FormLabel color="primary.500">Card Details</FormLabel>
                  <Box
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                    bg="white"
                    _focus={{ borderColor: "primary.500", boxShadow: "0px 0px 8px rgba(72, 187, 120, 0.8)" }}
                  >
                    <CardElement options={CARD_OPTIONS} />
                  </Box>
                </FormControl>
                <Flex mt={4} gap={4}>
                  <Button type="submit" isLoading={isPaymentLoading} colorScheme="teal">Save</Button>
                  <Button onClick={() => setIsAdding(false)} colorScheme="red">Cancel</Button>
                </Flex>
              </>
            )}
          </Box>
        ) : (
          <Flex align="center" gap={5}>
            <Text color="primary.100">Add Payment Method</Text>
            <IconButton aria-label="Add Payment Method" icon={<AddIcon />} size="sm" onClick={() => setIsAdding(true)} />
          </Flex>
        )}
      </Box>

      <Divider />

      {/* Bio Section */}
      <Box mb={8} mt={6}>
        <Heading size="md" mb={4} color="primary.500">
          Artist Bio
        </Heading>
        
        {profileLoading ? (
          <Card bg="secondary.500" borderRadius="md">
            <CardBody>
              <Flex align="center" justify="center" p={4}>
                <Spinner size="lg" color="primary.500" mr={4} />
                <Text color="primary.500">Loading your bio...</Text>
              </Flex>
            </CardBody>
          </Card>
        ) : isEditingBio ? (
          <VStack spacing={4} align="stretch">
            <Textarea
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              placeholder="Tell your fans about yourself..."
              size="md"
              resize="vertical"
              minH="120px"
              variant="filled"
              color="primary.100"
            />
            <Flex gap={4}>
              <Button
                onClick={updateBio}
                isLoading={bioLoading}
                colorScheme="teal"
                size="sm"
              >
                Save Bio
              </Button>
              <Button
                onClick={() => {
                  setIsEditingBio(false);
                  fetchUserProfile();
                }}
                colorScheme="red"
                variant="outline"
                size="sm"
              >
                Cancel
              </Button>
            </Flex>
          </VStack>
        ) : (
          <Card bg="secondary.500" borderRadius="md">
            <CardBody>
              <Flex justify="space-between" align="flex-start">
                <Box flex="1">
                  {bio ? (
                    <Text color="primary.100" fontSize="md" whiteSpace="pre-wrap">
                      {bio}
                    </Text>
                  ) : (
                    <Text color="gray.400" fontSize="md" fontStyle="italic">
                      No bio added yet. Click edit to add your artist bio.
                    </Text>
                  )}
                </Box>
                <IconButton
                  icon={<EditIcon />}
                  onClick={() => setIsEditingBio(true)}
                  size="sm"
                  variant="ghost"
                  color="primary.500"
                  aria-label="Edit bio"
                />
              </Flex>
            </CardBody>
          </Card>
        )}
      </Box>

      {/* Social Media Section */}
      <Box mb={8}>
        <Heading size="md" mb={4} color="primary.500">
          Social Media
        </Heading>
        
        {profileLoading ? (
          <Card bg="secondary.500" borderRadius="md">
            <CardBody>
              <Flex align="center" justify="center" p={4}>
                <Spinner size="lg" color="primary.500" mr={4} />
                <Text color="primary.500">Loading your social media...</Text>
              </Flex>
            </CardBody>
          </Card>
        ) : (
          <>
            {/* Existing Social Media */}
            <VStack spacing={3} mb={4}>
              {socialMedia && socialMedia.length > 0 ? socialMedia.map((social, index) => {
                const platform = socialPlatforms.find(p => p.value === social.platform);
                return (
                  <Card key={index} bg="secondary.500" borderRadius="md" w="100%">
                    <CardBody>
                      <Flex justify="space-between" align="center">
                        <Flex align="center" gap={3}>
                          <Icon as={platform?.icon} color={platform?.color} boxSize={6} />
                          <VStack align="start" spacing={0}>
                            <Text color="primary.100" fontWeight="bold" fontSize="sm">
                              {platform?.label}
                            </Text>
                            <Text color="primary.500" fontSize="sm">
                              @{social.handle}
                            </Text>
                          </VStack>
                        </Flex>
                        <IconButton
                          icon={<DeleteIcon />}
                          onClick={() => handleRemoveSocial(index)}
                          isLoading={socialLoading}
                          size="sm"
                          variant="ghost"
                          color="red.400"
                          aria-label="Remove social media"
                        />
                      </Flex>
                    </CardBody>
                  </Card>
                );
              }) : (
                <Box
                  bg="secondary.500"
                  borderRadius="md"
                  p={4}
                  textAlign="center"
                  border="2px dashed"
                  borderColor="dark.500"
                >
                  <Text color="primary.500" fontSize="sm" fontStyle="italic">
                    No social media platforms added yet. Click "Add Social Media Platform" below to get started.
                  </Text>
                </Box>
              )}
            </VStack>

            {/* Add New Social Media */}
            {isAddingSocial ? (
              <Card bg="secondary.500" borderRadius="md">
                <CardBody>
                  <VStack spacing={4} align="stretch">
                    <SimpleGrid columns={2} spacing={4}>
                      <FormControl>
                        <FormLabel color="primary.500" fontSize="sm">
                          Platform
                        </FormLabel>
                        <CustomSelect
                          value={newSocial.platform}
                          onChange={(value) => setNewSocial({ ...newSocial, platform: value })}
                          placeholder="Select platform"
                        >
                          {socialPlatforms.map((platform) => (
                            <option key={platform.value} value={platform.value}>
                              {platform.label}
                            </option>
                          ))}
                        </CustomSelect>
                      </FormControl>
                      
                      <FormControl>
                        <FormLabel color="primary.500" fontSize="sm">
                          Handle/Username
                        </FormLabel>
                        <Input
                          value={newSocial.handle}
                          onChange={(e) => setNewSocial({ ...newSocial, handle: e.target.value })}
                          placeholder="username"
                          variant="filled"
                          color="primary.100"
                        />
                      </FormControl>
                    </SimpleGrid>
                    
                    <Flex gap={4}>
                      <Button
                        onClick={handleAddSocial}
                        isLoading={socialLoading}
                        colorScheme="teal"
                        size="sm"
                      >
                        Add Social Media
                      </Button>
                      <Button
                        onClick={() => {
                          setIsAddingSocial(false);
                          setNewSocial({ platform: '', handle: '' });
                        }}
                        colorScheme="red"
                        variant="outline"
                        size="sm"
                      >
                        Cancel
                      </Button>
                    </Flex>
                  </VStack>
                </CardBody>
              </Card>
            ) : (
              <Flex align="center" gap={5}>
                <Text color="primary.100">Add Social Media Platform</Text>
                <IconButton 
                  aria-label="Add Social Media" 
                  icon={<AddIcon />} 
                  size="sm" 
                  onClick={() => setIsAddingSocial(true)} 
                />
              </Flex>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Settings;